class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

let cartTimerEnd = 0;

class CartTimer extends HTMLElement {
  connectedCallback() {
    this.duration = parseInt(this.dataset.minutes, 10) * 60000;
    if (!(this.duration > 0)) return;

    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    if (cartTimerEnd <= Date.now()) cartTimerEnd = Date.now() + this.duration;

    const seconds = Math.ceil((cartTimerEnd - Date.now()) / 1000);
    const pad = (n) => String(n).padStart(2, '0');
    this.textContent = `${pad(Math.floor(seconds / 60))}:${pad(seconds % 60)}`;
  }
}

customElements.define('cart-timer', CartTimer);

const CartUpsell = {
  init() {
    document.addEventListener('click', this.onClick.bind(this));
    document.addEventListener('keydown', this.onKeydown.bind(this));
    document.addEventListener('change', this.onChange.bind(this));
    document.addEventListener('focusout', this.onFocusOut.bind(this));
  },

  onClick(event) {
    const trigger = event.target.closest('.cart-upsell-swatch-dropdown .pw-swatch-trigger');
    if (trigger) {
      trigger.parentElement.classList.toggle('active');
      return;
    }

    const swatch = event.target.closest('.cart-upsell-swatch-dropdown .pw-swatch-item');
    if (swatch) {
      this.selectSwatch(swatch);
      return;
    }

    const button = event.target.closest('.cart-upsell__add-btn');
    if (button) this.add(button);
  },

  onKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const swatch = event.target.closest('.cart-upsell-swatch-dropdown .pw-swatch-item');
    if (swatch) {
      event.preventDefault();
      this.selectSwatch(swatch);
      return;
    }

    const dropdown = event.target.matches('.cart-upsell-swatch-dropdown') ? event.target : null;
    if (dropdown) {
      event.preventDefault();
      dropdown.classList.toggle('active');
    }
  },

  onFocusOut(event) {
    const dropdown = event.target.closest('.cart-upsell-swatch-dropdown');
    if (!dropdown) return;

    setTimeout(() => {
      if (!dropdown.contains(document.activeElement)) dropdown.classList.remove('active');
    }, 100);
  },

  selectSwatch(swatch) {
    const dropdown = swatch.closest('.cart-upsell-swatch-dropdown');
    dropdown.querySelectorAll('.pw-swatch-item').forEach((item) => item.classList.remove('is-selected'));
    swatch.classList.add('is-selected');

    const indicator = dropdown.querySelector('.selected-swatch-indicator');
    indicator.style.background = swatch.dataset.swatchBg;
    indicator.style.backgroundSize = 'cover';
    indicator.style.backgroundPosition = 'center';

    const select = dropdown.nextElementSibling;
    select.value = swatch.dataset.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    dropdown.classList.remove('active');
    swatch.blur();
  },

  onChange(event) {
    if (!event.target.matches('.cart-upsell__option-select')) return;

    const wrapper = event.target.closest('.cart-upsell__product-inner');
    const variants = JSON.parse(wrapper.querySelector('.cart-upsell-variant-json').textContent);
    const values = Array.from(wrapper.querySelectorAll('.cart-upsell__option-select'), (select) => select.value);
    const variant = variants.find((item) => item.options.every((option, index) => option === values[index]));
    const actions = wrapper.querySelector('.cart-upsell__actions');
    const button = actions.querySelector('.cart-upsell__add-btn');

    if (!variant) {
      button.textContent = actions.dataset.unavailableText;
      button.disabled = true;
      return;
    }

    button.dataset.variantId = variant.id;
    button.textContent = variant.available ? actions.dataset.addText : actions.dataset.soldOutText;
    button.disabled = !variant.available;
    wrapper.querySelector('.cart-upsell__current-price').innerHTML = variant.price;

    const image = wrapper.querySelector('.cart-upsell__image img');
    if (image && variant.image) {
      image.src = variant.image;
      image.srcset = `${variant.image} 1x, ${variant.image_2x} 2x`;
    }
  },

  add(button) {
    const variantId = parseInt(button.dataset.variantId, 10);
    if (!variantId) return;

    const actions = button.closest('.cart-upsell__actions');
    const miniCart = document.querySelector('mini-cart');
    const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];

    button.textContent = actions.dataset.addingText;
    button.disabled = true;

    fetch(theme.routes.cart_add_url, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          button.textContent = response.description || actions.dataset.unavailableText;
          setTimeout(() => {
            button.textContent = actions.dataset.addText;
            button.disabled = false;
          }, 2000);
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', productVariantId: variantId, cart: response });

        if (miniCart && response.sections) {
          miniCart.renderContents(response);
        } else {
          window.location.reload();
        }
      })
      .catch((e) => {
        console.error(e);
        button.textContent = actions.dataset.addText;
        button.disabled = false;
      });
  }
};

CartUpsell.init();
